module.exports = __webpack_public_path__ + "static/media/fvs_fremdlinge_52.80d45ef0.jpg";